export { default as CorporateContactEdit } from './CorporateContactEdit';